export enum BorderRadius {
  Square = '0',
  Soft = '2px',
  Round = '4px',
  VeryRound = '8px',
  ExtremelyRound = '20px',
  Circle = '50%',
}

export const darkeningImageBorderAlphaAsPercent = 7;
